import type { DayOffDay } from '../../../../shared/dpRequests';

const PERIOD_LABEL: Record<DayOffDay['period'], string> = {
    full: 'dia inteiro',
    morning: 'manhã',
    afternoon: 'tarde',
};

export function formatIsoDate(isoDate: string): string {
    const [year, month, day] = isoDate.split('-');
    return year && month && day ? `${day}/${month}/${year}` : isoDate;
}

export function formatDayOffDates(days: readonly DayOffDay[]): string[] {
    return days
        .slice()
        .sort((a, b) => a.date.localeCompare(b.date))
        .map(day => {
            const [year, month, dayOfMonth] = day.date.split('-');
            return `${dayOfMonth}/${month}/${year} (${PERIOD_LABEL[day.period]})`;
        });
}
